import React, { useContext } from "react";
import { FaCalendar, FaUserPlus } from "react-icons/fa";
import { FaChartLine } from "react-icons/fa6";
import { Link } from "react-router-dom";
import { GrLogout } from "react-icons/gr";
//get context
import { context } from "../../App";

function NavBar() {
  // Destructure the context as an array
  const [signIn, setSignIn] = useContext(context);

  const logout = () => {
    setSignIn(false);
  };
  return (
    <nav
      className="navbar navbar-light bg-light px-4"
      style={{ backgroundColor: "white" }}
    >
      <div className="d-flex align-items-center ms-auto">
        {/* <div className="input-group me-3" style={{ width: "300px" }}>
          <input
            type="text"
            className="form-control btn btn-outline-success"
            placeholder="Search..."
          />
          <button className="btn btn-outline-success">
            <FaSearch className="text-success" />
          </button>
        </div> */}
        <Link to="/members" className="btn btn-outline-info me-3">
          <FaUserPlus className="text-info" size={19} />
        </Link>
        <Link to="/events" className="btn btn-outline-success me-3">
          <FaChartLine className="text-success" size={20} />
        </Link>
        <Link to="/calendar" className="btn btn-outline-warning me-3">
          <FaCalendar className="text-warning" size={20} />
        </Link>
        <Link onClick={logout} className="btn btn-outline-danger me-3">
          Logout <GrLogout size={20} />
        </Link>
      </div>
    </nav>
  );
}
export default NavBar;
